export default __webpack_public_path__ + "static/first-book-cover-794d4a33a2d4c048c31cf47ebf875765.png";